'use client';
import type { Option } from '@susu/custom-made/utils/interfaces';
import { onEnter } from '@susu/custom-made/utils/utils';
import cn from 'classnames';

import styles from './navigation.module.scss';

export type Item =
  | {
      text: string;
      id: string;
      option?: Option;
      isActive: boolean;
      hasMissingValues: boolean;
    }
  | undefined;

export default function Navigation({
  items,
  testId,
  onItemClick,
}: Readonly<{
  items: Item[];
  testId: string;
  onItemClick: (item: Item | Option) => void;
}>) {
  return (
    <div className={styles.navigation} data-test-id={testId}>
      {items.map((item, index) => {
        if (item) {
          return (
            <div
              className={styles.buttonContainer}
              key={item.id}
              onClick={() => {
                onItemClick(item.option ?? item);
              }}
              tabIndex={index + 1}
              onKeyDown={e => {
                onEnter(e, () => {
                  onItemClick(item.option ?? item);
                });
              }}
            >
              <a
                className={cn({
                  [styles.isActive]: item.isActive,
                  [styles.hasMissingValues]: item.hasMissingValues,
                })}
                data-test-section={`${item.text}-Section`}
                data-test-id={`${item.id}`}
              >
                {item.text}
              </a>
            </div>
          );
        }
      })}
    </div>
  );
}
